import { styled } from '@mui/material';

import { Input } from '@knowz/knowz-ui';

const FULLY_ROUNDED = 99999;

const StyledInput = styled(Input)(({ theme }) => ({
  width: '100%',
  borderRadius: FULLY_ROUNDED,
  paddingRight: '0!important',
  marginTop: theme.spacing(7),
  marginBottom: theme.spacing(3),
}));

export default StyledInput;
